import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import {
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION,
  ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION,
} from "../../utils/constants";
import { logoPlatform } from "../../utils/string";
import { useTranslationApp } from "../../lib/i18next";
import {
  ADS_CAMPAIGN_TYPE_BUDGET_DAILY,
  ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION_UPDATE,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE,
  ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE_UPDATE,
  DATE_SHORT_LOCALIZED,
} from "../../i18n/keysTranslations";
import Typography from "@mui/material/Typography";
import { getPreviewAlertBudgets } from "../../services/adsCampaigns";
import { numberDecimal } from "../../utils/numbers";

const translations = {
  [ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION]: ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME,
  [ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION]: ADS_CAMPAIGN_TYPE_BUDGET_DAILY,
};

const ContainerBudgetAlert = ({ campaign, dispatch, mode = "create" }) => {
  const { t } = useTranslationApp();

  const budgetsInformation = getPreviewAlertBudgets({
    campaign,
    dispatch,
    mode,
  });
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        {mode === "create"
          ? t(ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE)
          : t(ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_TITLE_UPDATE)}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          mb: 3,
        }}
      >
        {mode === "create"
          ? t(ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION)
          : t(ALERT_ADS_CAMPAIGN_BUDGET_CONFIRM_DESCRIPTION_UPDATE)}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          {budgetsInformation.map((budget, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                }}
              >
                <Avatar
                  src={logoPlatform(budget.platform)}
                  variant="square"
                  sx={{
                    width: "20px",
                    height: "20px",
                    mr: 1,
                    ".MuiAvatar-img": {
                      objectFit: "contain",
                    },
                  }}
                />
                <Typography variant="body1">
                  {`${numberDecimal(budget.budget)} ${budget.currency}`}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Typography variant="body2">
                  {t(translations[budget.typeBudget])}
                </Typography>
                {budget.typeBudget ===
                  ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION &&
                  budget.startDate &&
                  budget.endDate && (
                    <Typography
                      variant="body2"
                      textAlign={"left"}
                      sx={{
                        whiteSpace: "nowrap",
                      }}
                    >
                      {`${t(DATE_SHORT_LOCALIZED, {
                        date: new Date(budget.startDate),
                      })} - ${t(DATE_SHORT_LOCALIZED, {
                        date: new Date(budget.endDate),
                      })}`}
                    </Typography>
                  )}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default ContainerBudgetAlert;
